import React from 'react';


import RoutedHeader from '../Header';
import BaseDetailScreen from '../BaseDetailScreen';

import './index.css';


class SimplePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      BodyComponent: () => <div>Loading...</div>,
    };
  }

  componentDidMount() {
    import(`.${this.props.page.path}`)
      .then(mod => this.setState({ BodyComponent: mod.default }));
  }

  render() {
    const { page } = this.props;
    const { BodyComponent } = this.state;
    return (
      <div>
        <RoutedHeader />
        <BaseDetailScreen
          pageHeading={page.title}
          showHeader={false}
        >
          <div styleName="body">
            <BodyComponent />
          </div>
        </BaseDetailScreen>
      </div>
    );
  }
}


export const createSimplePageComponent = page => () => <SimplePage page={page} />;

export const footerPages = [
  {
    path: '/terms-of-use',
    title: 'Terms of Use',
  },
  {
    path: '/privacy-policy',
    title: 'NOTICE OF MY IPO, LLC PRIVACY POLICY',
    footerLinkTitle: 'Privacy Policy',
  },
  {
    path: '/business-continuity-plan',
    title: 'Business Continuity Plan',
    footerLinkTitle: 'Business Continuity Plan',
  },
  {
    path: 'https://www.folioinstitutional.com/footer/sec-disclosure.jsp',
    title: 'SEC Rule 606',
  },
  {
    path: '/static/docs/Cambria_Capital_Form_CRS.pdf',
    title: 'Form CRS',
    openSeparately: true,
  },
];


export const allPages = [
  ...footerPages,
];



// WEBPACK FOOTER //
// ./src/components/SimplePages/index.js